<script setup>
import TitleComponent from '@/components/TitleComponent/index.vue'
import tabsView from '@/components/tabsView/index.vue'
import orderDetails from './orderDetails.vue'
import { onMounted, ref, reactive } from 'vue'
import topUpView from '@/components/topUpView/index.vue'
import { useUserStore } from '@/stores/userStore'
import { setWithdrawAPI, getWithdrawListAPI, getRebatesLogsAPI,getrRewardListAPI, getBankOrderListAPI, setCancelBankAPI, getModifyBankOrderAPI, getOrderDetailAPI, getConfigAPI, getExchangeRateAPI } from '@/apis/wallet'
import Prompt from './Prompt.vue'
import { useI18n } from 'vue-i18n'
import { formatToLocalTime, exchangeRateUSD, symbolStatus, formatToLocalTimeYMD, RateUSD } from '@/utils/index'
const { t, locale } = useI18n();
const userStore = useUserStore()
const dialogVisible = ref(false)
const PromptModel = ref(false)
const orderSn = ref();
const ipTime = userStore.ipTime;
const handleClose = (value, type, id) => {
    console.log(id)
    dialogVisible.value = false
    data.createOrder = {}
    if (type == 1) {
        orderSn.value = id
        PromptModel.value = true
    }
    userStore.getUser()

}
const Close = () => {
    PromptModel.value = false
    data.OrderFrom.page = 1
    getBankOrderList()
}

const data = reactive({
    OrderFrom: {
        order_no: '',
        bank_name: '',
        start_time: '',
        end_time: '',
        status: '',//:0 未支付,1 已支付,2 已收货
        bank_status: null,
        page: 1,
        page_size: 10
    },
    config: {
        user_withdraw_ratio: null, //用户提现手续费
        user_withdraw_min: null,//用户提现最低金额
    },
    exchangeRate: [],
    total: 0,
    setStatueFrom: {
        order_no: null,
        status: null
    },
    statusAll: [
        { label: t('number31'), value: 1 },
        { label: t('number32'), value: 2 },
        { label: t('number33'), value: 3 },
        { label: t('number34'), value: 4 },
    ],
    orderDetail: {},
    WithdrawList: [],
    WithdraFrom: {
        status: "",
        page: 1,
        page_size: 10
    },
    withdraTotal: 0,
    withdraStatus: [{ label: t('number35'), value: 1 },
    { label: t('number36'), value: 2 },
    { label: t('number37'), value: 3 },],
    withdrawalFrom: {
        amount: null,
        currency: "",
    },
    withdrawalAmount: 0,//实际到账
    checkexchangeRate: {
        change: null,
        currency: "",
        rate: null,
        symbol: ""
    },
    usdData: {},
    WithdrawalData: {},
    rebatesTotal: 0,
    affiliateTotal: 0,
    rebatesLogs: {
        is_invalid: "",
        is_used: "",
        page: 1,
        page_size: 10
    },
    affiliateLogs: {
        // is_invalid: "",
        // is_used: "",
        page: 1,
        page_size: 10
    },
    rebatesList: [],
    affiliateList: [],
    isInvalidData: [
        { label: t('setup87'), value: 1 },
        { label: t('setup88'), value: 2 },
    ],
    isUsedALL: [
        { label: t('setup89'), value: 1 },
        { label: t('setup90'), value: 2 },
        { label: t('setup91'), value: 3 },
    ]
})

const WithdraStatus = (state) => {
    const stateMap = {
        1: t('number35'),
        2: t('number36'),
        3: t('number37'),
    }
    return stateMap[state]
}
const fomartState = (state) => {
    const stateMap = {
        1: t('number31'),//待审核
        2: t('number32'),//通过
        3: t('number38'),//驳回
        4: t('number34')
    }
    return stateMap[state]
}
const isInvalidStatus = (state) => {
    const stateMap = {
        1: t('setup87'),
        2: t('setup88'),
    }
    return stateMap[state]
}
const isUsedStatus = (state) => {
    const stateMap = {
        1: t('setup89'),
        2: t('setup90'),
        3: t('setup91'),
    }
    return stateMap[state]
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    getExchangeRate()
    getConfig()
    getBankOrderList()
    userStore.getUser()
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);



})
/**
 * 获取订单列表
 */
const orderList = ref([])
const getBankOrderList = async () => {
    const res = await getBankOrderListAPI(data.OrderFrom)
    if (res.code == 0) {
        orderList.value = res.data.list,
            data.total = res.data.page.total
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const loading = ref(false)
const noMore = computed(() => {
    if (orderList.value) {
        if (orderList.value.length >= data.total) {
            return true;
        } else {
            return false;
        }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {
    loading.value = true
    setTimeout(async () => {
        data.OrderFrom.page++
        const res = await getBankOrderListAPI(data.OrderFrom)
        if (res.data.list) {
            orderList.value = [...orderList.value, ...res.data.list]
            loading.value = false
        }
    }, 100)
}


// 页数切换
const pageChange = (page) => {
    console.log(page);
    data.OrderFrom.page = page
    getBankOrderList()
}


/**
 * 
 * @param id 修改钱庄订单
 * @param type 
 */
const setState = async (id, type) => {
    data.setStatueFrom.order_no = id
    data.setStatueFrom.status = type
    const res = await getModifyBankOrderAPI(data.setStatueFrom)
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number39') })
        getBankOrderList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const statusClose = async (id) => {
    const res = await setCancelBankAPI({ order_no: id })
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number40') });
        getBankOrderList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}

/**
 * 
 * @param id 获取订单详情
 */
const walletDetails = ref(false)
const getOrderDetail = async (id) => {
    const res = await getOrderDetailAPI({ order_no: id })
    if (res.code == 0) {
        walletDetails.value = true
        data.orderDetail = res.data
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const DetailsClose = () => {
    walletDetails.value = false
    data.orderDetail = {}
}
const getList = () => {
    getBankOrderList()
}
const activeName = ref(1)

/**
 * 获取配置
 */

const getConfig = async () => {
    const res = await getConfigAPI()
    if (res.code == 0) {
        data.config = res.data
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const checkCurrency = ref()
/**
 * 获取汇率
 */
const getExchangeRate = async () => {
    const res = await getExchangeRateAPI()
    if (res.code == 0) {
        data.exchangeRate = res.data
        checkCurrency.value = userStore.exchangeRate.currency
        console.log('checkCurrency.value', checkCurrency.value)
        // console.log('汇率====',userStore.exchangeRate)
        // data.checkexchangeRate=userStore.exchangeRate
        // data.checkexchangeRate.change=data.exchangeRate[1].change;
        data.withdrawalFrom.currency = checkCurrency.value
        data.usdData = res.data.USD;
        console.log('data.usdData', data.usdData)
        changeCurrency(data.withdrawalFrom.currency)
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const changeCurrency = (value) => {
    // const findCurrency = data.exchangeRate.find(item => item.currency === value);
    // console.log(findCurrency)
    // data.checkexchangeRate=findCurrency
    // data.checkexchangeRate.change=data.exchangeRate[1].change;
    data.withdrawalFrom.amount = 0
    rete.value = RateUSD(value, data.usdData)
}

watch(() => data.withdrawalFrom.amount, (newValue, oldValue) => {
    console.log('值从', oldValue, '变为', newValue);

    data.withdrawalAmount = Number((newValue - newValue * (data.config.user_withdraw_ratio / 100)).toFixed(3).slice(0, -1))

}, { immediate: true });
/**
 * 提现
 */
const dialogWithdrawal = ref(false);
const amount = ref()
const WithdrawalClose = () => {
    dialogWithdrawal.value = false
    data.withdrawalFrom = {}
    // data.checkexchangeRate.change=data.exchangeRate[1].change;
    data.withdrawalFrom.currency = checkCurrency.value
    // data.withdrawalAmount=0
    tabChange(2)
}

const setWithdraw = async (row) => {

    const res = await setWithdrawAPI(row)
    if (res.code == 0) {
        WithdrawalClose()
        userStore.getUser()
        ElMessage({ type: 'success', message: t('number41') });
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}

const tabChange = (type) => {
    console.log(type)
    if (type == 2) {
        data.WithdraFrom.page = 1
        activeName.value = type
        getWithdrawList()
    } else if (type == 3) {
        data.rebatesLogs.page = 1
        activeName.value = type
        getRebatesLogs()
    } else if (type == 4) {
        data.affiliateLogs.page = 1
        activeName.value = type
        getAffiliateLogs()
    } else {
        data.OrderFrom.page = 1
        activeName.value = type
        getBankOrderList()
    }
}
const withdraPageChange = (page) => {

    data.WithdraFrom.page = page
    getWithdrawList()
}
/**
 * 获取提现列表
 */
const getWithdrawList = async () => {

    const res = await getWithdrawListAPI(data.WithdraFrom)
    if (res.code == 0) {
        data.WithdrawList = res.data.list,
            data.withdraTotal = res.data.page.total
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const loadings = ref(false)
const noMores = computed(() => {

    if (data.WithdrawList) {
        if (data.WithdrawList.length >= data.withdraTotal) {
            return true;
        } else {
            return false;
        }
    }
})
const disableds = computed(() => loadings.value || noMores.value)
const loads = () => {
    loadings.value = true
    setTimeout(async () => {
        data.WithdraFrom.page++
        const res = await getWithdrawListAPI(data.WithdraFrom)
        if (res.data.list) {
            data.WithdrawList = [...data.WithdrawList, ...res.data.list]
            loadings.value = false
        }
    }, 100)
}

/**
 * 提现详情
 */
const WithdrawalDetails = ref(false)
const getWithdrawalDetail = (row) => {
    data.WithdrawalData = row
    WithdrawalDetails.value = true
}
/**
 * 关闭提现详情
 */
const WithdrawalDrawerClose = () => {
    WithdrawalDetails.value = false
}

/**
 * 分红
 */
const getAffiliateLogs = async () => {
    const res = await getrRewardListAPI(data.affiliateLogs)
    if (res.code == 0) {
        data.affiliateList = res.data.list,
            data.affiliateTotal = res.data.page.total
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
/**
 * 分红
 */
const getRebatesLogs = async () => {
    const res = await getRebatesLogsAPI(data.rebatesLogs)
    if (res.code == 0) {
        data.rebatesList = res.data.list,
            data.rebatesTotal = res.data.page.total
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const Logsloading = ref(false)
const LogsnoMores = computed(() => {

    if (data.rebatesList) {
        if (data.rebatesList.length >= data.rebatesTotal) {
            return true;
        } else {
            return false;
        }
    }
})
const LogsAloading = ref(false)
const LogsAnoMores = computed(() => {

    if (data.rebatesList) {
        if (data.rebatesList.length >= data.rebatesTotal) {
            return true;
        } else {
            return false;
        }
    }
})
const Logsdisableds = computed(() => Logsloading.value || LogsnoMores.value)
const LogsAdisableds = computed(() => LogsAloading.value || LogsAnoMores.value)
const Logsloads = () => {
    Logsloading.value = true
    setTimeout(async () => {
        data.rebatesLogs.page++
        const res = await getRebatesLogsAPI(data.rebatesLogs)
        console.log(res)
        if (res.data.list) {
            data.rebatesList = [...data.rebatesList, ...res.data.list]
            Logsloading.value = false
        }
    }, 100)
}
const LogsAloads = () => {
    LogsAloading.value = true
    setTimeout(async () => {
        data.affiliateLogs.page++
        
        const res = await getrRewardListAPI(data.affiliateLogs)
        console.log(res)
        if (res.data.list) {
            data.affiliateList = [...data.affiliateList, ...res.data.list]
            LogsAloading.value = false
        }
    }, 100)
}
const LogsPageChange = (page) => {
    console.log(page);
    data.rebatesLogs.page = page
    getRebatesLogs()
}
const LogsAPageChange = (page) => {
    console.log(page);
    data.affiliateLogs.page = page
    getAffiliateLogs()
}
/**
 * 提现详情
 */
const RebatesLogsDetails = ref(false)
const getRebatesLogsDetail = (row) => {
    data.RebatesLogsData = row
    RebatesLogsDetails.value = true
}
/**
 * 关闭提现详情
 */
const RebatesLogsDrawerClose = () => {
    RebatesLogsDetails.value = false
}
const rete = ref()
// tab列表
const tabTypes = [
    { id: 1, name: t('number44') },
    { id: 2, name: t('number62') },
    { id: 3, name: t('setup84') },
    { id: 4, name: t('setup650') },
]
const customheaderrow = () => {
    return {
        backgroundColor: '#F3F6F8',
        fontFamily: 'MicrosoftYaHei',
        fontSize: '14px',
        color: '#11192D',
        lineHeight: '14px',
        padding: '21px 0',
    }
}
const rowbackground = () => {
    return {
        backgroundColor: '#F3F6F8',

    }
}
</script>

<template>
    <TitleComponent :title="t('number3')" v-if="isMobile == true"></TitleComponent>
    <div class="walletPage">
        <div class="header" v-if="isMobile == false">
            <div>{{ $t('number3') }}</div>
        </div>
        <div class="wallet" v-if="!isMobile">
            <div class="name">
                <img style="width: 20px;height: 18px;margin-right: 8px;" src="../../../assets/images/jinbi.png" alt=""
                    srcset="">
                <div class="lable">{{ $t('setup26') }}：</div>
                <div class="value">${{ userStore.userInfo?.balance }}
                </div>
            </div>
            <div class="walletbut HorizontalCenter" @click="dialogVisible = true">{{ $t('number42') }}</div>
            <div class="Withdrawalbut HorizontalCenter" @click="data.withdrawalAmount = 0; dialogWithdrawal = true;">{{
                $t('number43') }}</div>
        </div>
        <div class="wallet" v-else>
            <div> <img style="width: 20px;height: 18px;margin-right: 8px;" src="../../../assets/images/jinbi.png" alt=""
                    srcset="">
                <div class="lable">{{ $t('setup26') }}：</div>
            </div>
            <div>
                <div class="value">${{ userStore.userInfo?.balance }}
                </div>
                <div class="Withdrawalbut HorizontalCenter"
                    @click="data.withdrawalAmount = 0; dialogWithdrawal = true;">{{
                        $t('number43') }}</div>

            </div>
            <div class="walletbut HorizontalCenter" @click="dialogVisible = true">{{ $t('number42') }}</div>
        </div>
        <div class="consumelist">
            <tabsView :tabsList="tabTypes" @setCheckTabs="tabChange" :bottom="'false'" :left="true" class="tabsView">
            </tabsView>
            <div class="tableItem" v-if="activeName == 1">
                <div class="pc" v-if="isMobile == false">
                    <div class="search">
                        <el-input class="item" v-model="data.OrderFrom.order_no" clearable :placeholder="t('number45')">
                        </el-input>
                        <el-input class="item" v-model="data.OrderFrom.bank_name" clearable
                            :placeholder="t('number46')">

                        </el-input>
                        <el-select class="item" v-model="data.OrderFrom.status" placeholder="Select">
                            <el-option :label="t('number47')" :value="''"></el-option>
                            <el-option v-for="item in data.statusAll" :key="item.value" :label="item.label"
                                :value="item.value">
                                {{ item.label }}
                            </el-option>
                        </el-select>
                        <div class="searchBut">
                            <el-button type="primary" @click="getBankOrderList()"> {{ $t('number48') }}</el-button>
                        </div>
                    </div>
                    <div class="list">
                        <!-- :header-row-class-name="'custom-header-row'" -->
                        <el-table :data="orderList" style="width: 100%" :header-row-style="rowbackground"
                            :header-cell-style="customheaderrow">
                            <el-table-column prop="order_no" :label="t('number49')" show-overflow-tooltip />
                            <el-table-column prop="bank_name" :label="t('number50')" show-overflow-tooltip />
                            <el-table-column prop="order_credit" :label="t('number51')">
                                <template #default="scope">
                                    ${{ scope.row.order_credit }}
                                </template>
                            </el-table-column>

                            <el-table-column prop="status" :label="t('number52')">
                                <template #default="scope">
                                    {{ fomartState(scope.row.status) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="created_at" :label="t('number53')" show-overflow-tooltip>
                                <template #default="scope">
                                    {{ formatToLocalTime(ipTime, scope.row.created_at) }}
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="updated_at" :label="t('number54')" show-overflow-tooltip >
                                    <template #default="scope">
                                        {{formatToLocalTime(ipTime, scope.row.updated_at)}}
                                    </template>
                                </el-table-column> -->
                            <el-table-column :label="t('number55')">
                                <template #default="scope">
                                    <el-button type="primary" v-if="scope.row.status == 1"
                                        @click="setState(scope.row.order_no, 2)" size="small" text bg>
                                        {{ $t('number56') }}
                                    </el-button>
                                    <el-popover placement="bottom" trigger="click">
                                        <template #reference>
                                            <el-button type="primary" size="small" bg text> {{ $t('setup450')
                                                }}</el-button>

                                        </template>
                                        <div
                                            style="display: flex;justify-content: center;flex-direction: column;align-items: flex-end;">
                                            <el-button type="primary" v-if="scope.row.status == 1"
                                                @click="statusClose(scope.row.order_no)" size="small" text bg>
                                                {{ $t('number57') }}
                                            </el-button>
                                            <el-button style="margin-top: 8px;" type="primary"
                                                @click="getOrderDetail(scope.row.order_no)" size="small" bg text>{{
                                                    $t('number58') }}</el-button>
                                        </div>

                                    </el-popover>

                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="page">
                            <el-pagination :total="data.total" @current-change="pageChange"
                                :current-page="data.OrderFrom.page" :page-size="data.OrderFrom.page_size" background
                                layout="prev, pager, next" />
                        </div>
                    </div>
                </div>
                <div v-else class="list phone">
                    <div class="infinite-list-wrapper" style="overflow: auto">
                        <ul v-infinite-scroll="load" class="list" :infinite-scroll-disabled="disabled">
                            <div v-for="(item, i) in orderList" :key="i">
                                <div class="item logsdiv" @click="getOrderDetail(item.order_no)">
                                    <div class="sn">
                                        {{ $t('number59') }}：{{ item.order_no }}
                                    </div>
                                    <div class="content">
                                        <div> {{ $t('setup25') }}：</div>
                                        <div>
                                            {{ item.bank_name }}
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div> {{ $t('number105') }}：</div>
                                        <div>
                                            ${{ item.order_credit }}
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div> {{ $t('number65') }}：</div>
                                        <div style="color: #FC3938;">
                                            {{ fomartState(item.status) }}
                                        </div>
                                    </div>
                                    <!-- <div class="Default"> 
                                    </div> -->
                                    <!-- v-if="item.status == 1" -->
                                    <div class="but">
                                        <div v-if="item.status == 1" @click="setState(item.order_no, 2)"> {{
                                            $t('number56') }}</div>
                                        <div v-if="item.status == 1" @click="statusClose(item.order_no)"> {{
                                            $t('number57') }}</div>
                                        <div class="detail"> {{ $t('number58') }}</div>
                                        <!-- <el-button type="primary" 
                                            @click="setState(item.order_no, 2)" size="small" round>
                                            {{ $t('number56') }}
                                        </el-button>
                                        <el-button type="primary" 
                                            @click="statusClose(item.order_no)" size="small" round>
                                            {{ $t('number57') }}
                                        </el-button>
                                        <el-button type="primary" @click="getOrderDetail(item.order_no)" size="small"
                                            round>{{
                                                $t('number58') }}</el-button> -->



                                    </div>
                                </div>

                            </div>
                        </ul>
                        <p v-if="loading" style="text-align: center;padding-top: 10px;padding-bottom: 10px;">Loading...
                        </p>
                        <p v-if="noMore" style="text-align: center;padding-top: 10px;padding-bottom: 10px;">No more</p>
                    </div>
                </div>
            </div>
            <div class="tableItem" v-else-if="activeName == 2">
                <div class="pc" v-if="isMobile == false">
                    <div class="search">
                        <el-select class="item" v-model="data.WithdraFrom.status">
                            <el-option :label="t('number47')" :value="''"></el-option>
                            <el-option v-for="item in data.withdraStatus" :key="item.value" :label="item.label"
                                :value="item.value">
                                {{ item.label }}
                            </el-option>
                        </el-select>
                        <div class="searchBut">
                            <el-button type="primary" @click="getWithdrawList()"> {{ $t('number48') }}</el-button>
                        </div>
                    </div>
                    <div class="list">
                        <el-table :data="data.WithdrawList" style="width: 100%" :header-row-style="rowbackground"
                            :header-cell-style="customheaderrow">
                            <el-table-column prop="order_no" :label="t('number49')" show-overflow-tooltip />
                            <!-- <el-table-column prop="user_id" :label="t('number63')" show-overflow-tooltip /> -->

                            <el-table-column prop="currency" :label="t('setup69')" />
                            <el-table-column prop="exchange_rate" :label="t('setup70')" />

                            <el-table-column prop="amount" :label="t('number64')">
                                <template #default="scope">
                                    {{ symbolStatus(scope.row.currency) }}{{ scope.row.amount }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="commission" :label="t('setup71')">
                                <template #default="scope">
                                    {{ scope.row.commission }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="actual_receipt" :label="t('setup72')">
                                <template #default="scope">
                                    {{ symbolStatus(scope.row.currency) }}{{ scope.row.actual_receipt }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" :label="t('number65')">
                                <template #default="scope">
                                    {{ WithdraStatus(scope.row.status) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" :label="t('setup579')">
                                <template #default="scope">
                                    {{ scope.row.remark }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="create_at" :label="t('number66')" show-overflow-tooltip>
                                <template #default="scope">
                                    {{ formatToLocalTime(ipTime, scope.row.create_at) }}
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>
                    <div class="page">
                        <el-pagination :total="data.withdraTotal" :current-page="data.WithdraFrom.page"
                            @current-change="withdraPageChange" :page-size="data.WithdraFrom.page_size" background
                            layout="prev, pager, next" />
                    </div>
                </div>
                <div v-else class="list phone">
                    <div class="infinite-list-wrapper" style="overflow: auto">
                        <ul v-infinite-scroll="loads" class="list" :infinite-scroll-disabled="disableds">
                            <div v-for="(item, i) in data.WithdrawList" :key="i">
                                <div class="item logsdiv">
                                    <div class="sn">
                                        {{ $t('number59') }}:{{ item.order_no }}
                                    </div>
                                    <div class="content">
                                        <div>{{ $t('number66') }}: </div>
                                        <div>
                                            <div>{{ formatToLocalTime(ipTime, item.create_at) }}</div>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div>{{ $t('setup76') }}: </div>
                                        <div>
                                            <div>{{ symbolStatus(item.currency) }}{{ item.actual_receipt }}</div>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div> {{ $t('number65') }}：</div>
                                        <div :style="item.status == 3 ? 'color: #FC3938;' : ''">
                                            {{ WithdraStatus(item.status) }}
                                        </div>
                                    </div>
                                    <div class="content" v-if="item.remark">
                                        <div> {{ $t('setup579') }}：</div>
                                        <div>
                                            {{ item.remark }}
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div>
                                            <div> </div>
                                        </div>
                                        <div> <el-button type="primary" @click="getWithdrawalDetail(item)" size="small"
                                                round>{{
                                                    $t('number58') }}</el-button></div>
                                    </div>

                                </div>

                            </div>
                        </ul>
                        <p v-if="loadings" style="text-align: center;padding-top: 10px;padding-bottom: 10px;">Loading...
                        </p>
                        <p v-if="noMores" style="text-align: center;padding-top: 10px;padding-bottom: 10px;">No more</p>
                    </div>
                </div>
            </div>
            <div class="tableItem" v-else-if="activeName == 3">
                <div v-if="isMobile == false">
                    <div class="search">
                        <div style="display: flex;align-items: center;">
                            <div style="font-size: 14px;color: #909399;padding-right: 5px;">{{ $t('setup85') }}: </div>
                            <el-select class="item" v-model="data.rebatesLogs.is_invalid">
                                <el-option :label="t('number47')" :value="''"></el-option>
                                <el-option v-for="item in data.isInvalidData" :key="item.value" :label="item.label"
                                    :value="item.value">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                        </div>
                        <div style="display: flex;align-items: center;">
                            <div style="font-size: 14px;color: #909399;padding-right: 5px;">{{ $t('setup86') }}: </div>
                            <el-select class="item" v-model="data.rebatesLogs.is_used">
                                <el-option :label="t('number47')" :value="''"></el-option>
                                <el-option v-for="item in data.withdraStatus" :key="item.value" :label="item.label"
                                    :value="item.value">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                            <div class="searchBut">
                                <el-button type="primary" @click="getRebatesLogs()"> {{ $t('number48') }}</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="list">
                        <el-table :data="data.rebatesList" style="width: 100%" :header-row-style="rowbackground"
                            :header-cell-style="customheaderrow">
                            <el-table-column prop="order_no" :label="t('number49')" show-overflow-tooltip />
                            <!-- <el-table-column prop="user_id" :label="t('number63')" show-overflow-tooltip /> -->

                            <el-table-column prop="rebates_limit" :label="t('setup92')">
                                <template #default="scope">
                                    ${{ scope.row.rebates_limit }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="used_limit" :label="t('setup93')">
                                <template #default="scope">
                                    ${{ scope.row.used_limit }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="surplus_credit" :label="t('setup94')">
                                <template #default="scope">
                                    ${{ scope.row.surplus_credit }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="is_used" :label="t('setup95')">
                                <template #default="scope">
                                    {{ isUsedStatus(scope.row.is_used) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="is_invalid" :label="t('setup96')">
                                <template #default="scope">
                                    {{ isInvalidStatus(scope.row.is_invalid) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="created" :label="t('setup98')" show-overflow-tooltip>
                                <template #default="scope">
                                    {{ formatToLocalTimeYMD(ipTime, scope.row.created) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="expiration_time" :label="t('setup97')" show-overflow-tooltip>
                                <template #default="scope">
                                    {{ formatToLocalTimeYMD(ipTime, scope.row.expiration_time) }}
                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page">
                        <el-pagination :total="data.rebatesTotal" :current-page="data.rebatesLogs.page"
                            @current-change="LogsPageChange" :page-size="data.rebatesLogs.page_size" background
                            layout="prev, pager, next" />
                    </div>
                </div>
                <div v-else class="list phone">
                    <div class="infinite-list-wrapper" style="overflow: auto">
                        <ul v-infinite-scroll="Logsloads" class="list" :infinite-scroll-disabled="Logsdisableds">
                            <div v-for="(item, i) in data.rebatesList" :key="i">
                                <div class="item logsdiv">
                                    <div class="sn">
                                        {{ $t('number59') }}:{{ item.order_no }}
                                    </div>
                                    <div class="content">
                                        <!-- <div class="name"> {{ item.user_id }}</div> -->
                                        <div> {{ $t('setup98') }}</div>
                                        <div>
                                            <div>{{ formatToLocalTimeYMD(ipTime, item.created) }}</div>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <!-- <div class="name"> {{ item.user_id }}</div> -->
                                        <div> {{ $t('setup92') }}</div>
                                        <div>
                                            <div>${{ item.rebates_limit }}</div>
                                        </div>
                                    </div>

                                    <!-- <div class="content" v-if="item.is_used==2">
                                            <div>{{ $t('setup95') }} </div>
                                            <div>{{ isUsedStatus(item.is_used) }} </div>
                                        </div>
                                        <div class="content" v-if="item.is_invalid==2">
                                            <div>{{ $t('setup96') }} </div>
                                            <div>{{ isInvalidStatus(item.is_invalid) }} </div>
                                        </div> -->
                                    <div class="content" v-if="item.is_invalid == 1 && item.is_used != 2">
                                        <div>{{ $t('setup97') }} </div>
                                        <div>{{ formatToLocalTimeYMD(ipTime, item.expiration_time) }} </div>
                                    </div>
                                    <div class="content">
                                        <div>{{ $t('number65') }} </div>
                                        <div style="color: #FC3938;">{{ item.is_invalid =
                                        1 ? isUsedStatus(item.is_used) : isInvalidStatus(item.is_invalid) }}</div>
                                    </div>

                                    <div class="content">
                                        <div>
                                            <div> </div>
                                        </div>
                                        <div> <el-button type="primary" @click="getRebatesLogsDetail(item)" size="small"
                                                round>{{
                                                    $t('number58') }}</el-button></div>
                                    </div>
                                </div>

                            </div>
                        </ul>
                        <p v-if="loadings" style="text-align: center;padding-top: 10px;padding-bottom: 10px;">Loading...
                        </p>
                        <p v-if="noMores" style="text-align: center;padding-top: 10px;padding-bottom: 10px;">No more</p>
                    </div>
                </div>
            </div>
            <div class="tableItem" v-else>
                <div v-if="isMobile == false">
                    <div class="list">
                        <el-table :data="data.affiliateList" style="width: 100%" :header-row-style="rowbackground"
                            :header-cell-style="customheaderrow">
                            <el-table-column prop="nick_name" :label="t('cart38')" show-overflow-tooltip />
                            <el-table-column prop="expiration_time" :label="t('number66')" show-overflow-tooltip>
                                <template #default="scope">
                                    {{ formatToLocalTimeYMD(ipTime, scope.row.expiration_time) }}
                                </template>

                            </el-table-column>
                            <el-table-column prop="rebates_limit" :label="t('cart32')">
                                <template #default="scope">
                                    ${{ scope.row.amount }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="order_no" :label="t('number49')" show-overflow-tooltip />
                        </el-table>
                    </div>
                    <div class="page">
                        <el-pagination :total="data.affiliateTotal" :current-page="data.affiliateLogs.page"
                            @current-change="LogsAPageChange" :page-size="data.affiliateLogs.page_size" background
                            layout="prev, pager, next" />
                    </div>
                </div>
                <div v-else class="list phone">
                    <div class="infinite-list-wrapper" style="overflow: auto">
                        <ul v-infinite-scroll="LogsAloads" class="list" :infinite-scroll-disabled="LogsAdisableds">
                            <div v-for="(item, i) in data.affiliateList" :key="i">
                                <div class="item logsdiv">
                                    <div class="sn">
                                        {{ $t('number59') }}:{{ item.order_no }}
                                    </div>
                                    <div class="content">
                                        <div> {{ $t('setup98') }}</div>
                                        <div>
                                            <div>{{ formatToLocalTimeYMD(ipTime, item.created) }}</div>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div> {{ $t('setup92') }}</div>
                                        <div>
                                            <div>${{ item.amount }}</div>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div> {{ $t('cart38') }}</div>
                                        <div>
                                            <div>{{ item.nick_name }}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </ul>
                        <p v-if="loadings" style="text-align: center;padding-top: 10px;padding-bottom: 10px;">Loading...
                        </p>
                        <p v-if="noMores" style="text-align: center;padding-top: 10px;padding-bottom: 10px;">No more</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pc">
        <el-dialog class="modelwith" v-model="dialogWithdrawal" :title="t('number67')" width="450"
            :before-close="WithdrawalClose">
            <div class="title">{{ $t('setup74') }}</div>
            <el-select class="item" v-model="data.withdrawalFrom.currency" filterable style="width: 100%;"
                @change="changeCurrency">
                <el-option v-for="(value, key) in data.exchangeRate" :key="key" :label="key" :value="key">
                    {{ key }}
                </el-option>
            </el-select>
            <div class="title" v-if="data.withdrawalFrom.currency != 'USD'">{{ $t('setup70') }} : </div>
            <el-input v-if="data.withdrawalFrom.currency != 'USD'" v-model="rete" disabled style="width: 100%;">
                <!-- <template #append>%</template> -->
            </el-input>
            <div class="title">{{ $t('number64') }}</div>
            <el-input-number :precision="2"
                :max="exchangeRateUSD(userStore.userInfo?.balance, data.withdrawalFrom.currency, data.usdData)"
                :min="exchangeRateUSD(data.config.user_withdraw_min, data.withdrawalFrom.currency, data.usdData)"
                v-model="data.withdrawalFrom.amount" style="width: 100%;"
                :placeholder="`${t('setup73')}${exchangeRateUSD(data.config.user_withdraw_min, data.withdrawalFrom.currency, data.usdData)}${data.withdrawalFrom.currency}`" />
            <div class="title">{{ $t('setup75') }}</div>
            <el-input v-model="data.config.user_withdraw_ratio" disabled style="width: 100%;">
                <template #append>%</template>
            </el-input>
            <div class="title">{{ $t('setup76') }}</div>
            <el-input v-model="data.withdrawalAmount" disabled style="width: 100%;">
                <template #append>{{ data.withdrawalFrom.currency }}</template>
            </el-input>

            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="WithdrawalClose">Cancel</el-button>
                    <el-button type="primary" @click="setWithdraw(data.withdrawalFrom)">
                        {{ $t('number68') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
    <div class="phone">
        <el-drawer class="modelwith" v-model="dialogWithdrawal" :title="t('number67')" show-close :with-header="true"
            direction="btt" :before-close="WithdrawalClose" size="80%">
            <div class="title">{{ $t('setup74') }}

            </div>
            <el-select class="item" v-model="data.withdrawalFrom.currency" style="width: 100%;height: 38px;"
                @change="changeCurrency">
                <el-option v-for="(value, key) in data.exchangeRate" :key="key" :label="key" :value="key">
                    {{ key }}
                </el-option>
            </el-select>
            <div class="title" v-if="data.withdrawalFrom.currency != 'USD'">{{ $t('setup70') }} : </div>
            <el-input v-if="data.withdrawalFrom.currency != 'USD'" v-model="rete" disabled
                style="width: 100%;height: 38px;">
                <!-- <template #append>%</template> -->
            </el-input>
            <div class="title">{{ $t('number64') }}</div>
            <el-input-number :precision="2"
                :max="exchangeRateUSD(userStore.userInfo?.balance, data.withdrawalFrom.currency, data.usdData)"
                :min="exchangeRateUSD(data.config.user_withdraw_min, data.withdrawalFrom.currency, data.usdData)"
                v-model="data.withdrawalFrom.amount" style="width: 100%;height: 38px;"
                :placeholder="`${t('setup73')}${exchangeRateUSD(data.config.user_withdraw_min, data.withdrawalFrom.currency, data.usdData)}${data.withdrawalFrom.currency}`" />
            <div class="title">{{ $t('setup75') }}</div>
            <el-input v-model="data.config.user_withdraw_ratio" disabled style="width: 100%;height: 38px;">
                <template #append>%</template>
            </el-input>
            <div class="title">{{ $t('setup76') }}</div>
            <el-input v-model="data.withdrawalAmount" disabled style="width: 100%;height: 38px;">
                <template #append>{{ data.withdrawalFrom.currency }}</template>
            </el-input>
            <template #footer>
                <div class="dialog-footer">
                    <div @click="setWithdraw(data.withdrawalFrom)"> {{ $t('number68') }}</div>

                    <!-- <el-button @click="WithdrawalClose">Cancel</el-button>
                    <el-button type="primary" @click="setWithdraw(data.withdrawalFrom)">
                        {{ $t('number68') }}
                    </el-button> -->
                </div>
            </template>
        </el-drawer>
    </div>
    <topUpView v-if="dialogVisible" @handleClose="handleClose" :model="dialogVisible" @getList="getList"></topUpView>
    <Prompt v-if="PromptModel" :model="PromptModel" :id="orderSn" @Close="Close"></Prompt>
    <div class="pc">
        <el-dialog v-model="walletDetails" :title="t('number69')" width="650" :before-close="DetailsClose">
            <orderDetails v-if="walletDetails" :details="data.orderDetail"></orderDetails>
        </el-dialog>
    </div>
    <div class="phone">
        <el-drawer v-model="walletDetails" :title="t('number69')" show-close :with-header="true" direction="btt"
            :before-close="DetailsClose" size="80%">
            <!-- <el-dialog v-model="walletDetails" :title="t('number69')" width="100%" :before-close="DetailsClose"> -->
            <orderDetails v-if="walletDetails" :details="data.orderDetail"></orderDetails>
            <!-- </el-dialog> -->
        </el-drawer>
        <el-drawer v-model="WithdrawalDetails" :title="t('setup83')" show-close :with-header="true" direction="btt"
            :before-close="WithdrawalDrawerClose" size="80%">
            <div class="WithdrawalDetails">
                <div class="sn">{{ $t('number59') }}:{{ data.WithdrawalData.order_no }}</div>
                <div class="content">
                    <div class="item">
                        <div>{{ $t('number66') }}:</div>
                        <div>{{ formatToLocalTime(ipTime, data.WithdrawalData.create_at) }}</div>

                    </div>
                    <div class="item">

                        <div>{{ $t('setup74') }}:</div>
                        <div>{{ data.WithdrawalData.currency }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('number64') }}:</div>
                        <div>{{ symbolStatus(data.WithdrawalData.currency) }}{{ data.WithdrawalData.amount }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('setup70') }}:</div>
                        <div>{{ data.WithdrawalData.exchange_rate }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('setup75') }}:</div>
                        <div>{{ symbolStatus(data.WithdrawalData.currency) }}{{ data.WithdrawalData.commission }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('setup76') }}:</div>
                        <div>{{ symbolStatus(data.WithdrawalData.currency) }}{{ data.WithdrawalData.actual_receipt }}
                        </div>
                    </div>
                    <div class="item">
                        <div>{{ $t('number65') }}:</div>
                        <div>{{ WithdraStatus(data.WithdrawalData.status) }}</div>

                    </div>

                </div>
            </div>
        </el-drawer>

        <el-drawer v-model="RebatesLogsDetails" :title="t('setup84')" show-close :with-header="true" direction="btt"
            :before-close="RebatesLogsDrawerClose" size="80%">
            <div class="WithdrawalDetails">
                <div class="sn">{{ $t('number59') }}:{{ data.RebatesLogsData.order_no }}</div>
                <div class="content">
                    <div class="item">
                        <div>{{ $t('number66') }}:</div>
                        <div>{{ formatToLocalTime(ipTime, data.RebatesLogsData.created) }}</div>
                    </div>
                    <div class="item">

                        <div>{{ $t('setup92') }}:</div>
                        <div>${{ data.RebatesLogsData.rebates_limit }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('setup93') }}:</div>
                        <div>${{ data.RebatesLogsData.used_limit }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('setup94') }}:</div>
                        <div>${{ data.RebatesLogsData.surplus_credit }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('setup95') }}:</div>
                        <div>{{ isUsedStatus(data.RebatesLogsData.is_used) }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('setup96') }}:</div>
                        <div>{{ isInvalidStatus(data.RebatesLogsData.is_invalid) }}</div>
                    </div>
                    <div class="item">
                        <div>{{ $t('setup97') }}:</div>
                        <div>{{ formatToLocalTime(ipTime, data.RebatesLogsData.expiration_time) }}</div>

                    </div>

                </div>
            </div>
        </el-drawer>
    </div>
</template>

<style scoped lang="scss">
// :deep(.custom-header-row) {
//     background-color: #F3F6F8 ;
//     // border-radius: 8px 8px 0px 0px;
// }

.phone {
    display: none;
}

.pc {
    display: block;
}

.dialog {
    width: 500px;
}

.walletPage {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 8px;
    // padding: 0 20px;

    .header {
        padding: 31px 20px 20px 20px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #11192D;
        line-height: 18px;
        text-align: left;
        font-style: normal;



    }

    .wallet {
        margin: 0 20px;
        background: #FFF1EB;
        border-radius: 8px;
        border-radius: 10px;
        padding: 16px;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .name {
            flex: 1;
            display: flex;
            align-items: center;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #666666;
            line-height: 19px;
            text-align: left;
            font-style: normal;

            .lable {

                color: #666666;

            }

            .value {
                color: #FC3938;
            }
        }

        .walletbut {
            height: 36px;
            background: #FF5555;
            border-radius: 20px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            padding: 0 25px;


        }

        .Withdrawalbut {
            height: 36px;
            margin-left: 15px;
            // width: 80px;
            background: #FF9845;
            border-radius: 20px;
            color: #fff;
            padding: 0 25px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 19px;
            text-align: left;
            font-style: normal;
        }


    }

    .consumelist {
        padding-top: 20px;

        .tableItem {
            padding: 0 20px;
        }

        .listTitle {
            font-size: 18px;
            font-weight: 400;
            padding: 20px 10px;
        }

        .list {}

        .search {
            display: flex;
            padding: 0 0 20px 0;

            .item {
                width: 250px;
                padding-right: 50px;
            }
        }

        .page {
            display: flex;
            justify-content: flex-end;
            padding: 20px 0;
        }
    }
}

.dialogcontent {
    .title {
        font-size: 16px;
        padding: 8px 0;
    }

    .copy {
        padding: 20px 0;
        display: flex;
    }


    .CardList {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        grid-auto-rows: 50px;
        grid-gap: 10px;

        .itemCard {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #e4e7ed;
            border-radius: 5px;

            &:hover {
                background: #79bbff3b;
                border-radius: 5px;
                border: 1px solid #79bbff;
            }
        }

        .checkItemCard {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #79bbff3b;
            border-radius: 5px;
            border: 1px solid #79bbff;
        }
    }
}

.modelwith {
    .title {
        padding-top: 18px;
        padding-bottom: 6px;
    }
}

@media (max-width: 768px) {
    .pc {
        display: none !important;
    }

    .phone {
        display: flex;
        font-size: 14px;
    }

    .WithdrawalDetails {
        .sn {
            display: flex;
            justify-content: space-between;
            font-weight: 500;
            font-size: 15px;
            color: #20253A;
            padding: 0 0 20px 0;
        }

        .content {
            padding: 0;
            border: none;
            box-shadow: none;
            border-top: 1px solid #eee;
            padding-top: 15px;

            .item {
                // padding: 6px;
                display: flex;
                justify-content: space-between;
                padding: 10px 0;

                >div:last-child {
                    color: #888888;
                }
            }
        }

        // .content {
        //     padding: 10px;

        //     background: #FFFFFF;
        //     box-shadow: -2px 0px 10px 0px rgba(43, 45, 55, 0.02), 2px 0px 10px 0px rgba(43, 45, 55, 0.02);
        //     border-radius: 5px;
        //     border: 1px solid #EFF0F2;

        //     .item {
        //         padding: 6px;
        //         display: flex;
        //         justify-content: space-between;
        //     }
        // }
    }

    .walletPage {
        height: auto;
        margin-top: 25px;
        // padding: 2px 10px 0 10px;
        padding: 2px 0 0;
        background-color: #F8F8F8;

        // background-color: #F8F8F8;
        .header {
            height: 46px;
        }

        .wallet {
            border: none;
            border-radius: 10px;
            padding: 30px;
            margin-top: 30px;
            margin-left: 0px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            background-image: url('@/assets/images/walletbg.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            width: 100%;
            height: 200px;

            >div {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-family: 'PingFangSC';
                font-weight: 600;
                font-size: 12px;
                color: #FFFFFF;
                text-align: left;
                font-style: normal;

                .value {
                    font-size: 28px;
                    width: calc(100% - 110px);
                }

                .Withdrawalbut {
                    width: 100px;
                    height: 28px;
                    background: #D61F0E;
                    border-radius: 22px;
                    font-family: 'PingFangSC';
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;
                    line-height: 28px;
                    text-align: center;
                    font-style: normal;
                }
            }

            >div:nth-child(2) {
                justify-content: space-between;
            }

            .walletbut {
                display: block;
                margin-top: 10px;
                width: 100%;
                height: 44px;
                background: linear-gradient(119deg, #FFFFFF 0%, #FFE3D4 49%, #FFECB0 100%);
                box-shadow: 2px 5px 10px 3px rgba(217, 16, 16, 0.48);
                border-radius: 22px;
                font-family: 'PingFangSC';
                font-weight: 500;
                font-size: 15px;
                color: #FC3938;
                line-height: 44px;
                text-align: center;
                font-style: normal;
            }



        }

        .consumelist {
            margin: 0 15px;

            .tableItem {
                padding: 0;
            }

            .listTitle {
                padding: 10px 10px 56px 10px;
            }

            .search {
                flex-direction: column;
                padding: 0 0 10px 0;

                .item {
                    padding: 5px 0;
                    width: 310px;
                }
            }

            .list {
                font-size: 14px;
                display: flex;
                flex-direction: column;

                .item {
                    padding: 10px 10px;
                    border: 1px solid #dedfe0;
                    margin: 10px 0;
                    border-radius: 5px;

                    .content {
                        padding: 10px 0;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }

                    .about {
                        display: flex;
                        justify-content: space-between;
                    }

                    .but {
                        padding: 10px 0;
                        display: flex;
                        justify-content: flex-end;

                        >div {
                            height: 28px;
                            background: #F6F6F6;
                            border-radius: 14px;
                            font-family: 'PingFangSC';
                            font-weight: 400;
                            font-size: 12px;
                            color: #333333;
                            line-height: 28px;
                            text-align: center;
                            font-style: normal;
                            padding: 0 20px;
                            margin-right: 10px;
                        }

                        .detail {
                            color: #FC3938;
                            background-color: #FFF1EB;
                        }
                    }
                }

                .logsdiv {
                    position: relative;
                    background-color: #fff;
                    border: none;
                    padding: 0;

                    >div {
                        padding: 0 10px;
                    }

                    .content {
                        padding: 10px;
                    }

                    .sn {
                        height: 42px;
                        line-height: 42px;
                        border-bottom: 1px solid #eee;
                    }

                    .Default {
                        position: absolute;
                        right: 125px;
                        top: 50%;
                        background-color: rgba(241, 133, 55, 0.1411764706);
                        font-size: 12px;
                        color: #e26237;
                        width: 89px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 64px;
                        padding: 5px 0;
                    }
                }


            }
        }
    }

    .dialog-footer {
        >div {
            width: 100%;
            height: 40px;
            background: #ED4D34;
            border-radius: 20px;
            font-family: 'PingFangSC';
            font-weight: 500;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 40px;
            text-align: center;
            font-style: normal;
        }
    }


    :deep(.item .el-input--suffix) {
        height: 38px;
    }

    :deep(.el-drawer__title) {
        font-family: 'PingFangSC';
        font-weight: 500;
        font-size: 20px;
        color: #222222;
        line-height: 20px;
        text-align: left;
        font-style: normal;
    }
}
</style>